import { Column, UseFiltersColumnOptions } from 'react-table';
import { Quality, QualityColumnType } from '../../../../Types/LotDetailQuality';
import NoFilter from '../../../../DataTable/datatable.nofilter';
import QualityCell from './QualityCell';
import PrimaryCell from './PrimaryCell';
import LBMLabMinMaxCell from './LBMLabMinMaxCell';

export interface QualityColumnProps {
    header: string,
    qualityType: string,
    showConfidence?: boolean,
    qualityColumns?: QualityColumnType[],
}

function QualityColumn({ header, qualityType, showConfidence = false, qualityColumns = [] }: QualityColumnProps): Column<Quality> & UseFiltersColumnOptions<Quality> {
    return {
        Header: header,
        id: header,
        accessor: "qualityValues",
        Cell: ({ row }) => {
            switch (qualityType) {
                case "ASADDED":
                    return <PrimaryCell row={row} qualityType={qualityType} qualityColumns={qualityColumns} />;
                case "LBMLABMIN":
                    return <LBMLabMinMaxCell row={row} qualityType={qualityType} />;
                case "LBMLABMAX":
                    return <LBMLabMinMaxCell row={row} qualityType={qualityType} />;
                default:
                    return <QualityCell row={row} qualityType={qualityType} showConfidence={showConfidence} />;
            }
        },
        Filter: NoFilter
    };
}

export default QualityColumn;